import { useSearchStore } from '@/shared/lib/store';
import { useQueryClient } from '@tanstack/react-query';

export const SearchBarType1 = ({
    title,
    placeholder,
    inputTitle,
    setKeyword,
    setSearchNoResult,
}: {
    title: string;
    placeholder: string;
    inputTitle: string;
    setKeyword: (keyword: string) => void;
    setSearchNoResult: (value: boolean) => void;
}) => {
    const queryClient = useQueryClient();
    const { inKeyword, setInKeyword, setSearchPage } = useSearchStore();

    const onSearch = () => {
        setKeyword(inKeyword);
        setSearchPage(0);
        queryClient.resetQueries({ queryKey: ['created-list'] });
        setSearchNoResult(true);
    };

    return (
        <div className="searchbar">
            <span className="tit">{title}</span>
            <div className="keyword">
                <input
                    value={inKeyword}
                    type="text"
                    placeholder={placeholder}
                    title={inputTitle}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            onSearch();
                        }
                    }}
                    maxLength={200}
                    onChange={(e) => setInKeyword(e.target.value)}
                />
                <button className="btn-search btn icon" onClick={onSearch}>
                    <span className="blind">검색</span>
                </button>
            </div>
            {/* css props 처리해야할 경우 적용 필수. */}
        </div>
    );
};
